export default function faq() {
  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }
  jQuery(document).ready(function () {
    function updateFaqContainerHeights() {
      jQuery('.section-faq__body-container.open').each(function () {
        var container = jQuery(this);
        var body = container.find('.section-faq__body');
        var newHeight = body.outerHeight();
        container.css('height', newHeight + 'px');
      });
    }
    jQuery('.section-faq__header').on('click', function () {
      var container = jQuery(this).next('.section-faq__body-container');
      var body = container.find('.section-faq__body');
      if (container.hasClass('open')) {
        container.removeClass('open');
        container.animate({
          height: '0px'
        }, 300);
      } else {
        // Close any open containers
        jQuery('.section-faq__body-container.open').animate({
          height: '0px'
        }, 300).removeClass('open');

        // Open the clicked container
        container.addClass('open');
        var newHeight = body.outerHeight();
        container.animate({
          height: newHeight + 'px'
        }, 300);
      }
    });

    // Update heights on window resize and orientation change
    jQuery(window).on('resize orientationchange', debounce(updateFaqContainerHeights, 150));
  });
  jQuery(document).ready(function () {
    function updateFaqContainerHeights() {
      jQuery('.section-faq-columns__body-container.open').each(function () {
        var container = jQuery(this);
        var body = container.find('.section-faq-columns__body');
        var newHeight = body.outerHeight();
        container.css('height', newHeight + 'px');
      });
    }
    jQuery('.section-faq-columns__header').on('click', function () {
      var container = jQuery(this).next('.section-faq-columns__body-container');
      var body = container.find('.section-faq-columns__body');
      if (container.hasClass('open')) {
        container.removeClass('open');
        container.animate({
          height: '0px'
        }, 300);
      } else {
        // Close any open containers
        jQuery('.section-faq-columns__body-container.open').animate({
          height: '0px'
        }, 300).removeClass('open');

        // Open the clicked container
        container.addClass('open');
        var newHeight = body.outerHeight();
        container.animate({
          height: newHeight + 'px'
        }, 300);
      }
    });

    // Update heights on window resize and orientation change
    jQuery(window).on('resize orientationchange', debounce(updateFaqContainerHeights, 150));
  });
}